export default "__VITE_ASSET__68ba672e__"